<template>
  <div class="h-screen bg-gray-600 flex flex-col items-center justify-center">
    <Home />
  </div>
</template>

<script>
import Home from "./views/Home.vue";
export default {
    components: { Home }
}
</script>